// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__20rQ4","error":"Textarea_error__3fj4r","readonly":"Textarea_readonly__2To-P","disabled":"Textarea_disabled__16fm2"};